import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import SponsoredCard from './SponsoredCard';

/* The Promote slot: a member's project (B/N's own first), and how close you
   are to promoting yours — free for two weeks once 10 people join through
   your invites. */
export default function PromoteCard({ notify, onGo }) {
  const [status, setStatus] = useState(null);
  const [hasAd, setHasAd] = useState(null);
  useEffect(() => { api.promoteStatus().then(setStatus).catch(() => {}); }, []);

  const pct = status && !status.admin ? Math.min(100, Math.round((status.joined / status.next_at) * 100)) : 0;
  return (
    <section className="card rail-card promo-card" aria-label="Promote">
      <button type="button" className="promo-pill" onClick={() => onGo?.('promote')}>Promote</button>
      <SponsoredCard notify={notify} onGo={onGo} embedded onLoaded={setHasAd} />
      {hasAd === false && (
        <p className="promo-empty">Your project could be here — seen by builders it fits, measured by the connections it makes.</p>
      )}
      {status && !status.admin && (status.available ? (
        <button type="button" className="promo-earned" onClick={() => onGo?.('promote')}>
          🎉 You’ve earned a free {status.run_days}-day promotion — set it up
        </button>
      ) : (
        <div className="promo-progress" title="People who joined B/N through your invites">
          <span>Promote your project free: invite {status.next_at}</span>
          <span className="promo-bar" aria-hidden="true"><i style={{ width: `${pct}%` }} /></span>
          <b>{status.joined}/{status.next_at}</b>
        </div>
      ))}
    </section>
  );
}
